let $ = require('jquery');
let Vue = require('vue');
let SCI = require('sci');

Vue.directive('can', {
    priority: 1000,
    literal: true,

    bind: function () {
    },
    update: function (value) {
        let user = SCI.get('user');
        if(!user.guards[value]) {
            $(this.el).hide();
        } else {
            $(this.el).show();
        }
    },
    unbind: function () {
        //$(this.el).off().select2('destroy')
    }
});



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/components/can.js